import axios from "axios";

export const ROUTE_GROUPS = {
  redirect: 'redirect',
  article: 'articles',
  hash_tag: 'hash-tags',
  menu: 'menu-group',
  image: 'image',
  article_categories: 'article-categories',
  builder_components: 'builder-components',
  subscribers: 'subscribers',
  subscribe: 'subscribe',
  customer_questions: 'customer-questions',
  customer_question: 'get-in-touch',
  clearance_stocks: 'clearance-stocks',
  clearance_stock: 'clearance-stock',
  job_applies: 'job-applies',
  jobs: 'jobs',
  users: 'users',
  job_categories: 'job-categories',
  job_country: 'job-country',
  job_city: 'job-city',
  job_filters_languages: 'job-filters/languages',
  job_filters_contracts: 'job-filters/contracts',
  influencer_social_platforms: 'influencer/social-platforms',
  influencer_key: 'influencer/keys',
  influencer_tracking_pages: 'influencer/tracking-pages',
  influencer_tracking_pages_routes: 'influencer/tracking-pages/route-list',
  influencer_key_visitors: 'influencer/visitors',
  influencer_key_submits: 'influencer/submits',
}

export const API_PREFIX = '/admin-api'

/**
 * Auth routes
 */
export const axiosAuth = {
  auth: async ({email, password}) => await axios.post(`/auth/login`, {email, password}),
  forgotPassword: async ({email}) => await axios.post(`/auth/forgot-password`, {email}),
  forgotPasswordReset: async (data) => await axios.post(`/auth/forgot-password/reset`, data),
  logout: async () => await axios.post(`/auth/logout`),
}

export const axiosRedirects = {
  getList: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.redirect}`, {params}),
  getFilters: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.redirect}/filters`, {params}),
  createUpdate: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.redirect}/create-update`, data),
}

export const axiosSubscribers = {
  getList: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.subscribers}`, {params}),
  get: async (id) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.subscribers}/${id}`),
  export: async (params, responseType, headers) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.subscribers}/export-download`, {params, responseType, headers}),
}

export const axiosUsers = {
  getList: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.users}`, {params}),
  get: async (id) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.users}/${id}`),
  createUpdate: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.users}/create-update`, data),
  getRoles: async () => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.users}/get-roles`),
  getPermissions: async () => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.users}/get-permissions`),
  userPermissions: async () => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.users}/user-permissions`)
}

export const axiosSubscribe = {
  send: async (data) => await axios.post(`api/${ROUTE_GROUPS.subscribe}`, data),
}

export const axiosCustomerQuestions = {
  getList: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.customer_questions}`, {params}),
  get: async (id) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.customer_questions}/${id}`),
  export: async (params, responseType, headers) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.customer_questions}/export-download`, {params, responseType, headers}),
}

export const axiosCustomerQuestion = {
  send: async (data) => await axios.post(`api/${ROUTE_GROUPS.customer_question}`, data),
}

export const axiosJobApplies = {
  getList: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.job_applies}`, {params}),
  get: async (id) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.job_applies}/${id}`),
  download_cv: async (id, params, responseType, headers) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.job_applies}/download-cv/${id}`, {params, responseType, headers}),
  export: async (params, responseType, headers) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.job_applies}/export-download`, {params, responseType, headers}),
}

export const axiosClearanceStock = {
  getList: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.clearance_stocks}`, {params}),
  get: async (id) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.clearance_stocks}/${id}`),
  download_catalogue: async (id, params, responseType, headers) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.clearance_stocks}/download-catalogue/${id}`, {params, responseType, headers}),
  export: async (params, responseType, headers) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.clearance_stocks}/export-download`, {params, responseType, headers}),
}

export const axiosStock = {
  reasons: async () => await axios.get(`api/${ROUTE_GROUPS.clearance_stock}/overstock-reason`),
  send: async (data) => await axios.post(`api/${ROUTE_GROUPS.clearance_stock}`, data),
}

export const axiosImages = {
  upload: async (image) => await axios.post(
    `${API_PREFIX}/${ROUTE_GROUPS.image}/upload`,
    {image: image},
    {headers: {'Content-Type': 'multipart/form-data'}}
  ),
  uploadMultiple: async (images) => {
    let formData = new FormData()
    Array.from(images).forEach(image => {
      formData.append('images[]', image)
    })
    return await axios.post(
      `${API_PREFIX}/${ROUTE_GROUPS.image}/upload-multiple`,
      formData,
      {headers: {'Content-Type': 'multipart/form-data'}}
    )
  },
  searchList: async (data = {}, token = '') => {
    return await SEARCH_LIST(`${API_PREFIX}/${ROUTE_GROUPS.image}`, data, token)
  },
}

export const axiosArticles = {
  getList: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.article}${location.search}`, {params}),
  getFilters: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.article}/filters`, {params}),
  searchList: async (data = {}, token = '') => {
    return await SEARCH_LIST(`${API_PREFIX}/${ROUTE_GROUPS.article}`, data, token)
  },
  getLayouts: async () => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.article}/layouts`),
  getRecentTypes: async () => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.article}/recent-types`),
  getArticle: async (id) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.article}/${id}`),
  createUpdate: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.article}/create-update`, data),
  updateActive: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.article}/update-active`, data),
}

export const axiosInfluenceSocialPlatforms = {
  getList: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.influencer_social_platforms}`, {params}),
  getFilters: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.influencer_social_platforms}/filters`, {params}),
  createUpdate: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.influencer_social_platforms}/create-update`, data),
  updateActive: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.influencer_social_platforms}/update-active`, data),
}

export const axiosInfluenceKeys = {
  getList: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.influencer_key}`, {params}),
  getFilters: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.influencer_key}/filters`, {params}),
  createUpdate: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.influencer_key}/create-update`, data),
  updateActive: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.influencer_key}/update-active`, data),
  get: async (id) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.influencer_key}/${id}`),
}

export const axiosInfluenceTrackingPages = {
  getList: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.influencer_tracking_pages}`, {params}),
  getFilters: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.influencer_tracking_pages}/filters`, {params}),
  getRouteList: async () => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.influencer_tracking_pages_routes}`),
  createUpdate: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.influencer_tracking_pages}/create-update`, data),
  updateActive: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.influencer_tracking_pages}/update-active`, data),
}

export const axiosInfluenceVisitors = {
  getList: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.influencer_key_visitors}`, {params}),
  getFilters: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.influencer_key_visitors}/filters`, {params}),
}

export const axiosInfluenceSubmits = {
  getList: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.influencer_key_submits}`, {params}),
  getFilters: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.influencer_key_submits}/filters`, {params}),
}

export const axiosHashTags = {
  getList: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.hash_tag}`, {params}),
  getFilters: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.hash_tag}/filters`, {params}),
  searchList: async (data = {}, token = '') => {
    return await SEARCH_LIST(`${API_PREFIX}/${ROUTE_GROUPS.hash_tag}`, data, token)
  },
  updateActive: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.hash_tag}/update-active`, data),
  get: async (id) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.hash_tag}/${id}`),
  createUpdate: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.hash_tag}/create-update`, data),
}

export const axiosArticleCategories = {
  getList: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.article_categories}`, {params}),
  getFilters: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.article_categories}/filters`, {params}),
  searchList: async (data = {}, token = '') => {
    return await SEARCH_LIST(`${API_PREFIX}/${ROUTE_GROUPS.article_categories}`, data, token)
  },
  getItem: async (id) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.article_categories}/${id}`),
  createUpdate: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.article_categories}/create-update`, data),
  updateActive: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.article_categories}/update-active`, data),
}

export const axiosLocales = {
  getList: async () => await axios.get(`${API_PREFIX}/locales`),
}

export const axiosPageBuilder = {
  getList: async () => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.builder_components}/list`),
  getDefaultComponents: async () => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.builder_components}/default-components`),
  getComponentStructure: async (name) => {
    return await axios.get(
      `${API_PREFIX}/${ROUTE_GROUPS.builder_components}/structure`,
      {params: {name: name}}
    )
  },
}

export const axiosMenu = {
  getList: async () => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.menu}${location.search}`),
  getHomePage: async () => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.menu}/get-home-page`),
  createUpdateGroup: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.menu}/create-update`, data),
  getTypes: async () => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.menu}/get-types`),
  getMenuGroup: async (id) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.menu}/${id}`),
  getMenuList: async (id) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.menu}/${id}/menus${location.search}`),
  searchMenuList: async (id, data = {}, token = '') => {
    return await SEARCH_LIST(`${API_PREFIX}/${ROUTE_GROUPS.menu}/${id}/menus`, data, token)
  },
  updateActive: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.menu}/update-active`, data),
  getMenuItem: async (group_id, id) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.menu}/${group_id}/${id}`),
  createUpdateMenuItem: async (group_id, data) => {
    return await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.menu}/${group_id}/create-update`, data)
  },
}

export const axiosJobCountries = {
  getList: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.job_country}`, {params}),
  getFilters: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.job_country}/filters`, {params}),
  createUpdate: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.job_country}/create-update`, data),
  updateActive: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.job_country}/update-active`, data),
}

export const axiosJobCities = {
  getList: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.job_city}`, {params}),
  getFilters: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.job_city}/filters`, {params}),
  createUpdate: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.job_city}/create-update`, data),
  updateActive: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.job_city}/update-active`, data),
}

export const axiosJobFilters = {
  getLanguages: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.job_filters_languages}`, {params}),
  getLanguagesFilters: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.job_filters_languages}/filters`, {params}),
  createUpdateLanguage: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.job_filters_languages}/create-update`, data),
  updateActiveLanguage: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.job_filters_languages}/update-active`, data),
  getContracts: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.job_filters_contracts}`, {params}),
  getContractsFilters: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.job_filters_contracts}/filters`, {params}),
  createUpdateContract: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.job_filters_contracts}/create-update`, data),
  updateActiveContract: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.job_filters_contracts}/update-active`, data),
}

export const axiosJobCategories = {
  getList: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.job_categories}`, {params}),
  getFilters: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.job_categories}/filters`, {params}),
  createUpdate: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.job_categories}/create-update`, data),
  changeDefault: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.job_categories}/update-default`, data),
  updateActive: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.job_categories}/update-active`, data),
  getItem: async (id) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.job_categories}/${id}`),
}

export const axiosJobs = {
  getList: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.jobs}`, {params}),
  getFilters: async (params) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.jobs}/filters`, {params}),
  searchList: async (data = {}, token = '') => {
    return await SEARCH_LIST(`${API_PREFIX}/${ROUTE_GROUPS.jobs}`, data, token)
  },
  createUpdate: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.jobs}/create-update`, data),
  updateActive: async (data) => await axios.post(`${API_PREFIX}/${ROUTE_GROUPS.jobs}/update-active`, data),
  getItem: async (id) => await axios.get(`${API_PREFIX}/${ROUTE_GROUPS.jobs}/${id}`),
}

export const SEARCH_LIST = async (url, data = {}, token = '') => {
  let request_data = {
    params: data || {},
  }
  if (token) {
    request_data['cancelToken'] = token
  }
  return await axios.get(url, request_data)
}
